import { useState } from "react";
import "./services.css";
import basic from "./intmetricScout.png";
import intermediate from "./intmetric-compass.png";
import advanced from "./intmetricMap.png";










const serviceData = {
  "Web Design": {
    Basic: { price: "$1500", image: basic, features: ["Custom Branded Design", "4-6 Pages", "SEO Optimized","Mobile Friendly","Contact Form","Social Media Integration"], description: "A streamlined web design package that provides a modern, user-friendly site, ideal for businesses looking to establish a strong online presence quickly and efficiently." },
    Intermediate: { price: "$2500", image: intermediate, features: ["Custom Branded Design", "8-12 Pages", "Location Pages","SEO Optimized","Mobile Friendly","Contact Form","Social Media Integration"], description: "A professional web design package featuring a modern, responsive website tailored to your brand, with a strong focus on user experience and engagement." },
    Advanced: { price: "$3000", image: advanced, features: ["Custom Branded Design", "12-14 Pages", "Conversion Focused","Location Pages","Advanced SEO Optimized","Contact Form","Mobile Friendly","Social Media Integration"], description: "A premium web design solution offering a fully customized, SEO-optimized website with high-converting features and effortless navigation." }
  },
  "Google SEO": {
    Basic: { price: "$1500", image: basic, features: ["Keyword Research", "On-Page SEO", "Meta Tags"], description: "Get started with fundamental SEO techniques to improve your website's search visibility." },
    Intermediate: { price: "$2500", image: intermediate, features: ["Backlinks", "Content Strategy", "Technical SEO"], description: "Enhance your online presence with content-driven strategies and technical optimizations." },
    Advanced: { price: "$3000", image: advanced, features: ["Advanced Analytics", "SEO Automation", "Competitor Analysis"], description: "Dominate search rankings with AI-driven insights, automation, and competitive strategies." }
  },
  "Google Maps": {
    Basic: { price: "$1500", image: basic, features: ["Map Embedding", "Location Markers", "Basic Styling"], description: "Ideal for adding simple maps and location markers to your website or business page." },
    Intermediate: { price: "$2500", image: intermediate, features: ["Custom Markers", "Directions API", "Dynamic Data"], description: "Customize maps with dynamic data and navigation functionality for better user engagement." },
    Advanced: { price: "$3000", image: advanced, features: ["Geofencing", "Real-time Tracking", "Advanced Analytics"], description: "Optimize location-based services with real-time tracking and analytical insights." }
  }
};

export default function Services() {
  const [selectedService, setSelectedService] = useState("Web Design");

  return (
    <div className="services-container">
      <div className="buttons">
        {Object.keys(serviceData).map((service) => (
          <button
            key={service}
            className={selectedService === service ? "active" : ""}
            onClick={() => setSelectedService(service)}
          >
            {service}
          </button>
        ))}
      </div>

      <div className="cards-container">
        {Object.keys(serviceData[selectedService]).map((level) => (
          <div key={level} className="card">
            <img src={serviceData[selectedService][level].image} alt={level} className="card-image" />
            <h2>{level}</h2>
            <p className="price"><strong>{serviceData[selectedService][level].price}</strong></p>
            <p style={{textAlign:"left"}}>whats Included:</p>
            <ul>
              {serviceData[selectedService][level].features.map((item, index) => (
                <li key={index}>✅ {item}</li>
              ))}
            </ul>
            <p className="description">{serviceData[selectedService][level].description}</p>
            <button className="get-started">Get Started Today</button>
          </div>
        ))}
      </div>
    </div>
  );
}
